import * as React from 'react';

/**
 * Pencil Write SVG
 *
 * @returns
 */
function PencilWriteSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 29 32"
			className={'icon icon-pencil-write ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
			data-testid={svgProps.testId}
		>
			<path d="M1.455 24.727h5.818c0.015 0.001 0.033 0.001 0.050 0.001 0.383 0 0.727-0.163 0.968-0.423l0.001-0.001 16-16.013c0.268-0.257 0.434-0.619 0.434-1.019s-0.166-0.762-0.434-1.019l-0-0-5.818-5.831c-0.257-0.268-0.619-0.434-1.019-0.434s-0.762 0.167-1.019 0.434l-0 0-16.013 16.013c-0.261 0.242-0.424 0.586-0.424 0.969 0 0.018 0 0.035 0.001 0.053l-0-0.003v5.801c-0.002 0.030-0.004 0.065-0.004 0.1 0 0.759 0.615 1.374 1.374 1.374 0.030 0 0.059-0.001 0.088-0.003l-0.004 0zM2.909 18.038l14.545-14.545 3.78 3.78-14.545 14.545z" />
			<path d="M27.636 29.091h-26.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455h26.182c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455v0z" />
		</svg>
	);
}

PencilWriteSVG.defaultProps = { class: '' };

export default PencilWriteSVG;
